import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Auth } from './auth.reducer';

export const getAuth = createFeatureSelector<Auth>('auth');
export const getLoggedIn = createSelector(getAuth, (auth: Auth) => auth.loggedIn);
export const getUser = createSelector(getAuth, (auth: Auth) => auth.user);

export const getUserModules = createSelector(getAuth, (auth: Auth) => auth.userModules);

export const authQuery = {
  getAuth,
  getLoggedIn,
  getUser,
  getUserModules
};
